module.exports = __webpack_public_path__ + "static/img/license.6e76a09d.png";